import React from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import MaterialModal from "../../../../app/material-modal";
import { useQueryClient } from "@tanstack/react-query";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "sonner";
import { CreateSessionData } from "../types";
import { useSendInvitation } from "../../../../../tanstackQuery/queries/superAdmin/session";

export function SendInviteModal({ open, handleClose, inviteList, selectedRowData }) {
  
  const client = useQueryClient();
  const { keycloak } = useKeycloak();

  const {
    mutateAsync: createInvitation,
    isPending,
    isSuccess
  } = useSendInvitation(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["org-invite-sessions"] });
        handleClose();
      },
    }
  );

  const handleDeleteSession = async () => {    
     const { created, modified, createdF, modifiedF, payload, ...filteredData } = selectedRowData;

     const newPayload: CreateSessionData = {
        ...filteredData,
        status: "sent",
        data: JSON.stringify({
          ...inviteList,
        }),
     };

     try {
      await createInvitation(newPayload);
      if (isSuccess) {
        toast.success("Invitation sent successfully!");
      }
     } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to send invitation."
      );
     }
  };


  return (
    <>
      <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "200px",
              maxWidth: "400px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title="Invite User"
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Stack direction="row" gap={3} justifyContent="space-between">
            <Typography variant="body1" fontWeight={700}>Total user's going to have invitation</Typography>
            <Typography variant="body1" fontWeight={700}>{inviteList?.data?.length || 0}</Typography>
          </Stack>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            <Button 
              variant="contained"
              onClick={handleDeleteSession}
              disabled={isPending}
              endIcon={
                isPending ? <CircularProgress size={15} color="primary" /> : null
              }
            >
              Send
            </Button>
          </Box>
        </Box>
      </MaterialModal>

    </>
  );
}
